var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._m(0),_c('list')],1)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"px-8 py-4 white"},[_c('h1',{staticClass:"mt-2"},[_vm._v(" Conexiones ")])])}]

export { render, staticRenderFns }